import $ from 'jquery';

const setContactData = () => {
  if ($('.megaHeading-contact').length > 0) { return; }
  if(('sessionStorage' in window) && (window.sessionStorage !== null)) {
    sessionStorage.setItem('url', location.href);
    sessionStorage.setItem('title', document.title);
  }
};

const setLink = () => {
  if ($('.megaHeading-contact').length < 1) { return; }

  let url   = sessionStorage.getItem('url');
  let title = sessionStorage.getItem('title');

  if (!url) {
    //お問い合わせに直アクセスされた時用
    url = location.href;
    title = document.title;
  }

  url   = encodeURIComponent(url);
  title = encodeURIComponent(title);

  $('#contact').find('.fillButton-contact').each(function(){
    const $this = $(this);
    let href = $this.attr('href');
    href = href.replace( /&url=/g , "&url="+url );
    href = href.replace( /&title=/g , "&title="+title );
    $this.attr('href', href);
  });
};

module.exports = {
  setContactData : setContactData,
  setLink : setLink
};



// WEBPACK FOOTER //
// ./src/js/modules/contact.js